import { ValueType } from 'react-select'
import { useSelector } from 'react-redux'
import { useHistory,useLocation } from 'react-router-dom'
import { selectMapTerritory } from '../../selectors/PageMap'
import {
    selectTerritoryOptions,
    SelectOption,
} from '../../selectors/TerritoryFilters'
import { territoriesAreEqual } from '../../utils/territories'

export const useTerritorySelect = () => {
    const history = useHistory()
    const paramHideHeader = (new URLSearchParams(useLocation().search)).get('header') === 'false'
    const paramHideFooter = (new URLSearchParams(useLocation().search)).get('footer') === 'false'
    const territory = useSelector(selectMapTerritory)
    const options = useSelector(selectTerritoryOptions)
    const onChange = (option: ValueType<SelectOption>) => {
        if (option) {
            console.log((option as SelectOption).value.url!)
            history.push((option as SelectOption).value.url! + `${paramHideHeader==true ? '?header=false' :''}` + `${(paramHideFooter == true && paramHideHeader==true)  ?'&footer=false': (paramHideFooter == true && paramHideHeader==false) ? '?footer=false': ''}`)
        }
    }
    let selectedOption: SelectOption | null = null
    if (territory) {
        selectedOption = options.filter((option) =>
            territoriesAreEqual(option.value.territory, territory)
        )[0]
    }

    const filterOption = (option: SelectOption, query: string) => {
        if (option) {
            if (query.length && option.value.disabled) {
                return false
            }
            return option.value.territory.name
                .toLowerCase()
                .includes(query.toLowerCase())
        }
        return false
    }

    return { onChange, options, selectedOption, filterOption }
}
